import { useState } from "react";
import { useEstimatedCost } from "../hooks/estimated-cost.hook";
import { QueryEstimatedCostDto } from "../types";
import SquareButton from "@/modules/common/components/ui/square-button";
import { Box, Skeleton, Typography } from "@mui/material";
import EditFieldModal from "@/modules/common/components/modals/edit-field-modal";

export default function EstimatedCostButton({
  params,
  type,
}: {
  params: QueryEstimatedCostDto;
  type: "Finishing" | "rental";
}) {
  const [isOpen, setIsOpen] = useState(false);
  const { data, isLoading } = useEstimatedCost(params, isOpen);

  const title =
    type === "Finishing"
      ? "Estimated Finishing Cost"
      : "Estimated Rental Income";

  const value = type === "Finishing" ? data?.totalCost : data?.totalRent;

  const formattedValue =
    data && value
      ? `${data.currency} ${value.toLocaleString()}`
      : "No data available.";

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "left",
        alignItems: "center",
      }}
    >
      <SquareButton
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        View
      </SquareButton>
      <EditFieldModal
        header={title}
        modalFooter={false}
        open={isOpen}
        setOpen={setIsOpen}
        width={400}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100px",
          }}
        >
          {isLoading ? (
            <Skeleton
              variant="text"
              width={200}
              height={40}
              sx={{ marginBottom: "16px" }}
            />
          ) : (
            <Typography
              sx={(theme) => ({
                ...theme.nawy.typography.english.variants.headline.md,
              })}
            >
              {formattedValue}
            </Typography>
          )}
        </Box>
      </EditFieldModal>
    </Box>
  );
}
